import "./GpHomeSection.scss";
import clsx from "clsx";
import { Section, CardDoctor } from "@/components";
import { DayHours } from "@anoki/fse-common";
import { ColorKeys } from "@/theme/colors";

type Info = {
  label: string;
  value: string;
};

type ScheduleDay = {
  label: string;
  slots: DayHours[];
};

export type GpHomeSectionProps = {
  sectionId?: string;
  title?: string;
  className?: string;
  doctorName?: string;
  specialties?: string[];
  contactInfo?: Info[];
  schedule?: {
    label: string;
    days: ScheduleDay[];
  };
  avatar?: {
    initials: string;
    bg?: ColorKeys;
    textColor?: ColorKeys;
  };
  button?: {
    label: string;
    onClick: () => void;
  };
};

export const GpHomeSection = ({
  sectionId,
  title,
  className,
  doctorName = "",
  specialties,
  contactInfo,
  schedule,
  avatar,
  button,
}: GpHomeSectionProps) => {
  return (
    <div
      id={sectionId}
      className={clsx("gp-home-section section-gap", className)}
    >
      <Section className="gp-home-section-card">
        {title && (
          <Section.Title
            fs="3"
            mdFs="2"
            className="gp-home-section-title"
            as="h3"
          >
            {title}
          </Section.Title>
        )}
        <div className="gp-home-section-content">
          <CardDoctor
            doctorName={doctorName}
            specialties={specialties}
            contactInfo={contactInfo}
            schedule={schedule}
            avatar={avatar}
            button={button}
          />
        </div>
      </Section>
    </div>
  );
};
